import { Skeleton } from './Skeleton';
import { SkeletonCircle } from './SkeletonCircle';

/**
 * Skeleton for individual notification item.
 */
export const NotificationItemSkeleton = () => {
  return (
    <div className="flex gap-4 p-4 bg-surface rounded-lg">
      <SkeletonCircle size="w-10 h-10" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
};

/**
 * Skeleton for notification list.
 */
export const NotificationListSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="space-y-3 px-4 py-6">
      {Array.from({ length: count }).map((_, index) => (
        <NotificationItemSkeleton key={index} />
      ))}
    </div>
  );
};
